module.exports = __webpack_public_path__ + "img/pc-tab-icon3.16d1d33a.png";